import { render } from "./workflow-setup.vue?vue&type=template&id=e968bce6&scoped=true"
import script from "./workflow-setup.vue?vue&type=script&lang=js"
export * from "./workflow-setup.vue?vue&type=script&lang=js"

import "./workflow-setup.vue?vue&type=style&index=0&id=e968bce6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e968bce6"]])

export default __exports__